import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Home from "@/pages/Home";
import StatePage from "@/pages/StatePage";
import CityPage from "@/pages/CityPage";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import MapPage from "@/pages/MapPage";
import BrowsePage from "@/pages/BrowsePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/browse" element={<Navigate to="/browse/hotels" replace />} />
          <Route path="/browse/:tab" element={<BrowsePage />} />
          <Route path="/state/:state" element={<StatePage />} />
          <Route path="/state/:state/city/:city" element={<CityPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
        </Routes>
        <footer className="border-t border-[var(--line)] mt-16 sm:mt-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 flex items-center justify-between flex-wrap gap-3">
            <div className="font-label text-[10px] text-[var(--ink-soft)]">
              © 2026 · Hospitality Presence Deck · India
            </div>
            <div className="font-label text-[10px] text-[var(--ink-soft)]">Est. across 28 States · 8 UTs</div>
          </div>
        </footer>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
